"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var adapter_1 = require("../core/adapter");
var RuntimeDataSourceItem_1 = require("../core/RuntimeDataSourceItem");
var reloadDataSourceFactory_1 = require("../core/reloadDataSourceFactory");
var helpers_1 = require("../helpers");
/**
 * @param dataSource
 * @param context
 * @param extraConfig: { requestHandlersMap }
 */
exports.default = (function (dataSource, context, extraConfig) {
    if (extraConfig === void 0) { extraConfig = { requestHandlersMap: {} }; }
    var requestHandlersMap = extraConfig.requestHandlersMap;
    var runtimeDataSource = adapter_1.adapt2Runtime(dataSource, context);
    var dataSourceMap = runtimeDataSource.list.reduce(function (prev, current) {
        prev[current.id] = new RuntimeDataSourceItem_1.RuntimeDataSourceItem(current, helpers_1.getRequestHandler(current, requestHandlersMap), context);
        return prev;
    }, {});
    return {
        dataSourceMap: dataSourceMap,
        reloadDataSource: reloadDataSourceFactory_1.reloadDataSourceFactory(runtimeDataSource, dataSourceMap, runtimeDataSource.dataHandler),
    };
});
